var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux/~/lodash/_getPrototype.js
 ** module id = 921
 ** module chunks = 0
 **/